import { render, staticRenderFns } from "./Listado2.vue?vue&type=template&id=1a52a986&"
import script from "./Listado2.vue?vue&type=script&lang=js&"
export * from "./Listado2.vue?vue&type=script&lang=js&"
import style0 from "./Listado2.vue?vue&type=style&index=0&id=1a52a986&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports